import React from 'react';
import { useIntl } from 'react-intl';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';
import { withFlags } from '@confluence/flags/entry-points/withFlags.ts';

import { feedbackCollectorMessages } from './FeedbackCollectorButton.tsx';
import { SpaceRolesFeedbackCollector } from './SpaceRolesFeedbackCollector.tsx';

const PageActionsFeedbackCollectorComponent = ({
	flags,
	isOpen,
	onClose,
	source,
}: {
	flags: FlagsStateContainer;
	isOpen: boolean;
	onClose: () => void;
	source: string;
}) => {
	const { formatMessage } = useIntl();

	return (
		<SpaceRolesFeedbackCollector
			isOpen={isOpen}
			onClose={onClose}
			onSubmit={() => {
				void flags.showSuccessFlag({
					title: formatMessage(feedbackCollectorMessages.flagTitle),
					isAutoDismiss: true,
				});
			}}
			source={source}
		/>
	);
};

export const PageActionsFeedbackCollector: React.ComponentType<
	Omit<
		{
			flags: FlagsStateContainer;
			isOpen: boolean;
			onClose: () => void;
			source: string;
		},
		'flags'
	>
> = withFlags(PageActionsFeedbackCollectorComponent);
